import axios from 'axios'

/** Long enough for a slow API, short enough that a hung one cannot leave Create or Save unresponsive. */
export const PATIENT_IDENTIFIER_LOOKUP_TIMEOUT_MS = 8000

/**
 * Looks up the patient in an organisation who holds an identifier.
 * @param {string} organisationId
 * @param {string} identifier
 * @returns {Promise<?Object>} the patient, or null for an empty response
 * @throws on a request failure, a timeout, or a 404 rejected by the axios interceptor
 */
export async function fetchPatientByIdentifier(organisationId, identifier) {
    let response = await axios.get(`${process.env.VUE_APP_AXIOS_PATIENT_BASE_URL}/api/v1/patients/getByIdentifier/${encodeURIComponent(organisationId)}/${encodeURIComponent(identifier)}`, {timeout: PATIENT_IDENTIFIER_LOOKUP_TIMEOUT_MS})
    return response.data && Object.keys(response.data).length ? response.data : null
}
